<mat-card>
    <div class="border-left card px-3">
        <div class="my-2 p-0">
            <button type="button" class="btn btn-outline-secondary btn-sm border-0"
                    [matMenuTriggerFor]="cardHeaderMenu">
                Graphique<i class="fa-solid fa-angle-down ms-2"></i>
            </button>

        </div>
        <div class="charts mb-25 mx-3 row">

            <div class="line border col-lg-8" [chart]="lineChart">

            </div>
  
        </div>
    </div>
</mat-card>

<mat-menu #cardHeaderMenu="matMenu" class="card-header-menu" xPosition="after">
    @for (type of chartTypes; track $index) {
        <button mat-menu-item (click)="handleChartType(type)">
            {{ type.toUpperCase() }}
        </button>
    }
</mat-menu>

<mat-menu #durationMenu="matMenu" class="card-header-menu" xPosition="after">
    @for (duration of duration; track $index){
        <button mat-menu-item (click)="handleDuration(duration)">{{duration}}</button>
    }

</mat-menu>
